<template>
    <div>
        <div class="container-fluid mt-2 ">
            <div class="row">
                <!-- Existing form section -->
                <div class="col-md-12 mb-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <h4>Signos vitales</h4>
                                <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son obligatorios.</p>
                                <div class="row">
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Presión Arterial <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" v-model.trim="signosVitales.presion_arterial" />
                                        <small class="form-text text-muted">Ingrese la presión arterial en formato "120/80".</small>
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Temperatura (°C) <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.temperatura" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Frecuencia Cardíaca (lpm) <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.frecuencia_cardiaca" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Frecuencia Respiratoria (rpm) <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.frecuencia_respiratoria" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Peso (kg) <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.peso" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Estatura (m) <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.estatura" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">IMC <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.imc" disabled />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Saturación de Oxígeno (%) <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.saturacion_oxigeno" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Glucosa (mg/dL) <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model.number="signosVitales.glucosa" />
                                    </div>
                                </div>
                                <div class="col-md-12 text-center">
                                    <vs-button type="submit" color="rgb(59,222,200)" gradient block @click="guardarSignosVitales">
                                        {{ isUpdating ? 'Actualizar signos' : 'Agregar signos vitales' }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "SignosVitales",
        props: {
            consulta_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                signosVitales: {
                    presion_arterial: '',
                    temperatura: 0,
                    frecuencia_cardiaca: 0,
                    frecuencia_respiratoria: 0,
                    peso: 0,
                    estatura: 0,
                    imc: 0,
                    saturacion_oxigeno: 0,
                    glucosa: 0
                },
                isUpdating: false // Indica si se están actualizando los signos vitales
            };
        },
        watch: {
            'signosVitales.peso': 'calcularIMC',
            'signosVitales.estatura': 'calcularIMC'
        },
        mounted() {
            this.cargarSignosVitales();
        },
        methods: {
            async cargarSignosVitales() {
                try {
                    const response = await axios.get(`${API}/obtener_signos_vitales`, {
                        params: { consulta_id: this.consulta_id }
                    });

                    if (response.data.status === 'success') {
                        this.signosVitales = response.data.data;
                        this.$emit('enviaSignos', this.signosVitales);
                        this.isUpdating = true; // Cambiar a modo de actualización
                    }
                } catch (error) {
                    if (error.response?.status === 404) {
                    } else {
                        this.notify('error', `Error al cargar signos vitales: ${error.response?.data?.message || error.message}`);
                    }
                }
            },
            calcularIMC() {
                const { peso, estatura } = this.signosVitales;
                if (peso > 0 && estatura > 0) {
                    this.signosVitales.imc = (peso / (estatura ** 2)).toFixed(2);
                } else {
                    this.signosVitales.imc = null;
                }
            },
            async guardarSignosVitales() {
                if (!this.consulta_id) {
                    this.notify('error', 'El campo "consulta_id" es obligatorio.');
                    return;
                }

                // Validar cada campo individualmente
                if (!this.vEmpty(this.signosVitales.presion_arterial, 'Presión Arterial')) return;
                if (!/^\d+\/\d+$/.test(this.signosVitales.presion_arterial)) {
                    this.notify('error', 'El formato de la Presión Arterial debe ser "diastólica/sistólica".');
                    return;
                }
                if (!this.vNumber(this.signosVitales.temperatura, 'Temperatura')) return;
                if (!this.vNumber(this.signosVitales.frecuencia_cardiaca, 'Frecuencia Cardíaca')) return;
                if (!this.vNumber(this.signosVitales.frecuencia_respiratoria, 'Frecuencia Respiratoria')) return;
                if (!this.vNumber(this.signosVitales.peso, 'Peso')) return;
                if (this.signosVitales.peso >= 600) {
                    this.notify('error', 'El peso esta fuera de rango.');
                    return;
                }
                if (!this.vNumber(this.signosVitales.estatura, 'Estatura')) return;
                if (!this.vNumber(this.signosVitales.saturacion_oxigeno, 'Saturación de Oxígeno')) return;
                if (!this.vNumber(this.signosVitales.glucosa, 'Glucosa')) return;

                try {
                    const endpoint = this.isUpdating
                        ? `${API}/actualizar_signos_vitales`
                        : `${API}/insertar_signos_vitales`;

                    const method = this.isUpdating ? 'put' : 'post';

                    const response = await axios[method](endpoint, {
                        consulta_id: this.consulta_id,
                        ...this.signosVitales
                    });

                    if (response.data.status === 'success') {
                        const message = this.isUpdating
                            ? 'Signos vitales actualizados exitosamente'
                            : 'Signos vitales insertados exitosamente';
                        this.notify('success', message);
                        this.cargarSignosVitales(); // Recargar signos vitales
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            resetForm() {
                this.signosVitales = {
                    presion_arterial: '',
                    temperatura: 0,
                    frecuencia_cardiaca: 0,
                    frecuencia_respiratoria: 0,
                    peso: 0,
                    estatura: 0,
                    imc: 0,
                    saturacion_oxigeno: 0,
                    glucosa: 0
                };
                this.isUpdating = false;
            }
        }
    };
</script>

<style>
    /* Add any necessary styles here */
</style>